export default __webpack_public_path__ + "static/media/featured-collection-2.8a57d1f8.jpg";